import StatementAlert from './StatementAlert';

export default StatementAlert;
